class ShopTheLookOnClick {
    constructor(section, staticIcon = null, mobileOverlay = null) {
        this.section = section;
        this.cartIconShopTheLook = this.section ? this.section.querySelector('[data-shop-the-look-toggle]') : null;
        this.closeButton = this.section ? this.section.querySelector('[data-shop-the-look-close]') : null;
        this.productsContainer = this.section ? this.section.querySelector('[data-shop-the-look-products]') : null;
        this.mobileOverlay = (this.section ? this.section.querySelector('[data-shop-the-look-mobile-overlay]') : null) || mobileOverlay;
        this.shopTheLookStaticIcon = staticIcon;
        this.imageContainer = this.section ? this.section.querySelector('[data-shop-the-look-image]') : null;
        this.init();
    }

    init() {
        if (this.cartIconShopTheLook) {
            this.cartIconShopTheLook.addEventListener('click', (e) => {
                e.preventDefault();
                this.toggle();
            });
        }

        if (this.closeButton) {
            this.closeButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.close();
            });
        }

        if (this.shopTheLookStaticIcon) {
            this.shopTheLookStaticIcon.addEventListener('click', (e) => {
                e.preventDefault();
                this.toggle();
            });
        }

        if (this.mobileOverlay) {
            this.mobileOverlay.addEventListener('click', (e) => {
                // Only close if the overlay itself (not a child) is clicked
                if (e.target === this.mobileOverlay) {
                    e.preventDefault();
                    this.close();
                }
            });
        }

        if (this.imageContainer) {
            this.imageContainer.addEventListener('click', (e) => {
                console.log("click")
                if (e.target === this.imageContainer && this.section.classList.contains('is-open')) {
                    this.close();
                }
            });
        }
    }

    toggle() {
        if (!this.section) return;
        const isOpen = this.section.classList.contains('is-open');
        if (isOpen) {
            this.close();
        } else {
            this.open();
        }
    }

    open() {
        if (!this.section) return;
        this.section.classList.add('is-open');
        this.section.classList.remove('is-closed');
        if (this.mobileOverlay) {
            this.mobileOverlay.classList.add('is-open');
            this.mobileOverlay.classList.remove('is-closed');
        }
        this.updatePanelState();
        // Lock scroll on mobile when overlay is open
        if (window.theme && typeof window.theme.isMobile === 'function' && window.theme.isMobile() && this.mobileOverlay && this.mobileOverlay.classList.contains('is-open')) {
            document.documentElement.setAttribute('data-scroll-locked', '');
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = '0px';
        }
    }

    close() {
        if (!this.section) return;
        this.section.classList.remove('is-open');
        this.section.classList.add('is-closed');
        if (this.mobileOverlay) {
            this.mobileOverlay.classList.remove('is-open');
            this.mobileOverlay.classList.add('is-closed');
        }
        this.updatePanelState();
        // Unlock scroll on mobile when overlay is closed
        if (window.theme && typeof window.theme.isMobile === 'function' && (!this.mobileOverlay || !this.mobileOverlay.classList.contains('is-open'))) {
            document.documentElement.removeAttribute('data-scroll-locked');
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        }
    }

    updatePanelState() {
        if (!this.section) return;
        const isOpen = this.section.classList.contains('is-open');
        const panel = this.section.querySelector('[data-shop-the-look-panel]');

        if (panel) {
            panel.setAttribute('data-panel-state', isOpen ? 'open' : 'closed');
        }

        if (this.productsContainer) {
            this.productsContainer.setAttribute('aria-hidden', (!isOpen).toString());
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".brick__section").forEach(block => {
        const icon = block.querySelector(".shop-the-look-static__container_icon");
        const heroContent = block.querySelector(".hero__content");

        if (icon && heroContent) {
            heroContent.classList.add("margin-bottom-60");
        }
    });
});


// Initialize all shop-the-look components
document.addEventListener('DOMContentLoaded', function () {
    // Initialize on-click sections
    const onClickSections = document.querySelectorAll('.shop-the-look-on-click-section');
    onClickSections.forEach(section => {
        new ShopTheLookOnClick(section);
    });

    // Initialize static sections
    const staticIcons = document.querySelectorAll('[data-shop-the-look-static-icon]');
    staticIcons.forEach(icon => {
        // Find the associated container for this icon
        const container = icon.nextElementSibling;
        if (container && container.classList.contains('shop-the-look-static__container')) {
            // Find the mobile overlay (it should be before the icon)
            const mobileOverlay = icon.previousElementSibling;
            new ShopTheLookOnClick(container, icon, mobileOverlay);
        }
    });
});